// extracted by mini-css-extract-plugin
export default {"companyContainer":"W1-z","companyImage":"X1-z","container":"Y1-z","heading":"Z1-z","darkText":"_1-z","smallHeading":"a2-z","darkBackground":"b2-z","whiteBackground":"c2-z"};